import './globals.css';
// Player CSS — focused stylesheet for the Artplayer-based player, ambient
// glow, and loading/error overlays.
import './components/player/player-ui.css';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { StrictMode } from 'react';

import { routes } from './routes';

const router = createBrowserRouter(routes);

hydrateRoot(
  document.getElementById('root') as HTMLElement,
  <StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </StrictMode>
);
